import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import MarketsLayout from '@fuww/library/src/Markets';
import ListItem from '@fuww/library/src/Markets/ListItem';
import { List, ListDivider } from '@fuww/library/src/List';
import LinkAndAnchor from '../LinkAndAnchor';
import Head from '../Head';
import ImageWithUrls from '../ImageWithUrls';
import getStandsBreadcrumbs from './getBreadcrumbs';
import connectionType from '../Markets/connectionType';
import throw404 from '../../lib/throw404';
import messages from '../../lib/messages';

const Stands = ({
  data: {
    market,
  },
}) => {
  const intl = useIntl();

  if (!market) {
    return throw404();
  }

  const {
    id: marketId,
    name: marketName,
    description,
    standsConnection,
  } = market;

  return (
    <>
      <Head
        title={
          intl.formatMessage(messages['stands.title'], { name: marketName })
        }
        description={description}
        payload={{ marketId }}
      />
      <MarketsLayout
        title={
          intl.formatMessage(messages['stands.headingTitle'], {
            name: marketName,
          })
        }
        description={description}
        breadcrumbs={getStandsBreadcrumbs({ marketName, marketId })}
      >
        <List>
          {
            standsConnection.edges.map(({ node: { id, name, imageUrls } }) => (
              <Fragment key={id}>
                <li>
                  <LinkAndAnchor
                    route="stand"
                    params={{ marketId, standId: id }}
                  >
                    <ListItem
                      title={name}
                      image={imageUrls[0] && (
                        <ImageWithUrls
                          alt={name}
                          width="100px"
                          height="auto"
                          sizes="100px"
                          imageUrls={imageUrls}
                          srcSet={`${imageUrls[1]
                          } 100w, ${imageUrls[2]
                          } 200w`}
                          placeholderLoadStrategy="instant"
                        />
                      )}
                    />
                  </LinkAndAnchor>
                </li>
                <ListDivider />
              </Fragment>
            ))
          }
        </List>
      </MarketsLayout>
    </>
  );
};

Stands.propTypes = {
  data: PropTypes.shape({
    market: PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      description: PropTypes.string,
      standsConnection: connectionType,
    }),
  }),
};

Stands.defaultProps = {
  data: null,
};

export default Stands;
